import { useStickyDiff } from './useStickyDiff';
import { useLoading, useError } from '../api/hooks';
import { ActionType } from '../redux/actionType';
import { useTimedToggle } from './useTimedToggle';


/**
 * Use this to set a temporary toggle that fires whenever the specified action returns with success status.
 *
 * @param actionType - the type of action to trigger the callback
 * @param requestId - the request Id (if any) of the specific action which should trigger the callback
 * @param startToggled - whether or not the hook should initialize as toggled. Default: `false`
 * @param delay - the duration in milliseconds for which the state should remain toggled. Default: `15000`
 */
export const useTimedToggleOnSuccess = (
  actionType: ActionType,
  requestId: string | number | undefined = undefined,
  startToggled?: boolean | (() => boolean),
  delay?: number,
): boolean => {
  const [value, setValue] = useTimedToggle(startToggled, delay);
  const isLoading = useLoading(actionType, requestId);
  const hasError  = !!useError(actionType, requestId);

  useStickyDiff(
    (prev, next) => {
      if (!!prev?.isLoading && !next.isLoading && !next.hasError)
        setValue();
      },
    {
      isLoading: isLoading,
      hasError:  hasError,
    },
  );

  return value;
};
